<div class="engagement-card-item-header mb-2">
  {{ engagement().clientName }}

  @if (engagement().actionRequired) {
    <pill color="red" [dark]="true" size="small" value="ACTION REQUIRED" />
  }
</div>

<h3 class="mb-2">{{ engagement().name }}</h3>

@if (engagement().prepaymentStatus; as prepaymentStatus) {
  <pill [color]="EngagementListPrepaymentStatusColor[prepaymentStatus]" [value]="EngagementListPrepaymentStatusDisplay[prepaymentStatus]">{{ engagement().statusDate }}</pill>
} @else {
  <pill [color]="EngagementListStatusColor[engagement().status]" [value]="EngagementListStatusDisplay[engagement().status]">{{ engagement().statusDate }}</pill>
}
